module.exports = __webpack_public_path__ + "img/coco_bg.ed88fa3.png";